import {CookiesEnum} from "../model/cookies.enum";
import {CookiesHooksEnum} from "../model/cookies-hooks.enum";

export class ServiceInjectorService {
    private readonly cookieServicesMap = new Map<CookiesEnum, (() => void)[]>();
    private readonly hooksServicesMap = new Map<CookiesHooksEnum, ((state: boolean) => void)[]>();

    constructor(
        private window: Window,
        private document: Document
    ) {
    }

    prepare(serviceFn: () => void, cookieClass: CookiesEnum): void {
        if (!this.cookieServicesMap.has(cookieClass)) {
            this.cookieServicesMap.set(cookieClass, []);
        }

        this.cookieServicesMap.get(cookieClass).push(serviceFn.bind({
            window: this.window,
            document: this.document
        }));
    }

    hook(serviceFn: (state: boolean) => void, cookieHook: CookiesHooksEnum): void {
        if (!this.hooksServicesMap.has(cookieHook)) {
            this.hooksServicesMap.set(cookieHook, []);
        }

        this.hooksServicesMap.get(cookieHook).push(serviceFn.bind({
            window: this.window,
            document: this.document
        }));
    }

    resolve(cookieClass: CookiesEnum): void {
        if (!this.cookieServicesMap.has(cookieClass)) {
            return;
        }

        while (this.cookieServicesMap.get(cookieClass).length) {
            this.cookieServicesMap.get(cookieClass).shift()();
        }
    }

    commitHook(state: boolean, cookieHook: CookiesHooksEnum): boolean {
        if (!this.hooksServicesMap.has(cookieHook)) {
            return state;
        }

        while (this.hooksServicesMap.get(cookieHook).length) {
            this.hooksServicesMap.get(cookieHook).shift()(state);
        }

        return state;
    }

    /**
     * since we can't reject specific services we just reload page without them.
     */
    reject(): void {
        this.document.location.reload();
    }
}
